import React from "react";
import doctors from "../../../../assets/images/doctors.png";
import py from "../../../../assets/images/py-electronics.png";
import furnitures from "../../../../assets/images/furnitures.png";

const Works = () => {
  return (
    <div className="my-4 text-white text-center text-xl font-bold">
      <h3 className="text-2xl mb-4">Projects</h3>
      <h1 className="text-5xl text-pink-600 font-bold mb-4">
        Check My Recent Works
      </h1>
      <p data-aos="zoom-in-down" data-aos-delay="0" className="text-xl py-2 lg:max-w-md mx-auto">
        The following Projects most of themes used Node.js,Express.js,MongoDB
        with React.js. and liked to take any new challenges thats can make a
        wonderful projects.
      </p>

      <div className="items-center grid grid-cols-1 lg:grid-cols-3 py-8 gap-5">
        <div data-aos="flip-right" data-aos-duration="1500" data-aos-delay="2" className="card w-80 mx-auto bg-base-100 shadow-xl">
          <figure>
            <img src={py} alt="Shoes" />
          </figure>
          <div className=" max-w-sm mx-auto mt-3 grid grid-cols-3 gap-8 px-10">
            <div class="badge badge-secondary">Express.js</div>
            <div class="badge badge-secondary">MongoDB</div>
            <div class="badge badge-secondary">React.js</div>
          </div>
          <div className="card-body grid grid-cols-1 lg:grid-cols-2">
            <div className="">
              <a
                target="_blank"
                href="https://py-electronis.firebaseapp.com/"
              rel="noreferrer"
              >
                <button className="btn btn-accent btn-xs">Live Preview</button>
              </a>
            </div>
            <div>
              <a
              rel="noreferrer"
                target="_blank"
                href="https://github.com/AlaminSarkerFRII/Electronics-Manufacturers"
              >
                <button className="btn btn-accent btn-xs">Code Preview</button>
              </a>
            </div>
          </div>
        </div>
        <div data-aos="flip-up" data-aos-duration="2000" data-aos-delay="3" className="card w-80 mx-auto bg-base-100 shadow-xl">
          <figure>
            <img src={doctors} alt="Shoes" />
          </figure>
          <div className=" max-w-sm mx-auto mt-3 grid grid-cols-3 gap-8 px-10">
            <div class="badge badge-secondary">Express.js</div>
            <div class="badge badge-secondary">MongoDB</div>
            <div class="badge badge-secondary">React.js</div>
          </div>
          <div className="card-body grid grid-cols-1 lg:grid-cols-2">
            <div className="">
              <a
              rel="noreferrer"
                target="_blank"
                href="https://doctors-portal-f2968.web.app/"
              >
                <button className="btn btn-accent btn-xs">Live Preview</button>
              </a>
            </div>
            <div>
              <a
              rel="noreferrer"
                target="_blank"
                href="https://github.com/AlaminSarkerFRII/doctors-portal"
              >
                <button className="btn btn-accent btn-xs">Code Preview</button>
              </a>
            </div>
          </div>
        </div>
        <div data-aos="flip-left" data-aos-duration="3000" data-aos-delay="2" className="card w-80 mx-auto bg-base-100 shadow-xl">
          <figure>
            <img src={furnitures} alt="Shoes" />
          </figure>
          <div className=" max-w-sm mx-auto mt-3 grid grid-cols-3 gap-8 px-10">
            <div class="badge badge-secondary">Express.js</div>
            <div class="badge badge-secondary">MongoDB</div>
            <div class="badge badge-secondary">React.js</div>
          </div>
          <div className="card-body grid grid-cols-1 lg:grid-cols-2">
            <div className="">
              <a
              rel="noreferrer"
                target="_blank"
                href="https://good-foods-a594c.firebaseapp.com/"
              >
                <button className="btn btn-accent btn-xs">Live Preview</button>
              </a>
            </div>
            <div>
              <a
              rel="noreferrer"
                target="_blank"
                href="https://github.com/AlaminSarkerFRII/Furniture-Warehouse-managements-system"
              >
                <button className="btn btn-accent btn-xs">Code Preview</button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="px-20 text-white py-10">
        <hr className="text-2xl" />
      </div>
    </div>
  );
};

export default Works;
